import EmailTemplateForm from "./EmailTemplateForm";

export default EmailTemplateForm;
